export default "__VITE_ASSET__CRUOf2FU__"